import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';
import { ProcessSchedulerService } from 'app/core/services/process-scheduler.service';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'dialog-process-invoice',
  templateUrl: './dialog-process-invoice.component.html',
  styleUrls: ['./dialog-process-invoice.component.scss']
})
export class DialogProcessInvoiceComponent implements OnInit {

  payrolls: any[] = [];
  sss: any[] = [];
  philhealth: any[] = [];
  pagibig: any[] = [];
  processForm: FormGroup;
  schedules: any[] = [];

  payrollCtrl = new FormControl('');
  sssCtrl = new FormControl('');
  philhealthCtrl = new FormControl('');
  pagIbigCtrl = new FormControl('');


  filteredProcess!: Observable<any[]>;
  filteredSSS!: Observable<any[]>;
  filteredPhilhealth!: Observable<any[]>;
  filteredPagIbig!: Observable<any[]>;

  scheduleCtrl = new FormControl('');
  filteredSchedules!: Observable<any[]>;
  loading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogProcessInvoiceComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService, private fb: FormBuilder, private processSchedulerService: ProcessSchedulerService) {
    this.processForm = this.fb.group({
      schedule: ['', Validators.required],
      selectedDate: ['', Validators.required],
      sss: ['', Validators.required],
      philhealth: ['', Validators.required],
      pagibig: ['', Validators.required],
      // schedule: ['', Validators.required],
      // startDate: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getPayrolls();
    this.getComputations();
    this.getSchedules();

    this.filteredProcess = this.payrollCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.payrolls, 'name'))
    );

    this.filteredSSS = this.sssCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.sss, 'name'))
    );

    this.filteredPhilhealth = this.philhealthCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.philhealth, 'name'))
    );

    this.filteredPagIbig = this.pagIbigCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.pagibig, 'name'))
    );

    this.filteredSchedules = this.scheduleCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.schedules, 'name'))
    );
  }

  private _filter(value: string, list: any[], key: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return list?.filter(item => item[key]?.toLowerCase().includes(filterValue));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getSchedules() {
    this.processSchedulerService.getSchedules().subscribe({
      next: res => {
        this.schedules = res;
        this.filteredSchedules = this.scheduleCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value, this.schedules, 'name'))
        );
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getPayrolls() {
    this.processSchedulerService.getPayrollProcesses().subscribe(res => {
      console.log(res);
      this.payrolls = res;
      this.filteredProcess = this.payrollCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value, this.payrolls, 'name'))
      );
    });
  }

  getComputations() {
    this.processSchedulerService.getComputations().subscribe({
      next: res => {
        this.sss = res;
        this.philhealth = res;
        this.pagibig = res;

        this.filteredSSS = this.sssCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value, this.sss, 'name'))
        );

        this.filteredPhilhealth = this.philhealthCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value, this.philhealth, 'name'))
        );

        this.filteredPagIbig = this.pagIbigCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value, this.pagibig, 'name'))
        );
      },
      error: err => {
        console.log(err);
      }
    });
  }

  onPayrollSelected(name: string) {
    const selected: any = this.payrolls.find(d => d.name === name);
    if (selected) {
      this.processForm.get('payroll')?.setValue(selected.id);
    }
  }

  onSSSSelected(name: string) {
    const selected = this.sss.find(e => e.name === name);
    if (selected) {
      this.processForm.get('sss')?.setValue(selected.value);
    }
  }

  onPhilhealthSelected(name: string) {
    const selected = this.philhealth.find(e => e.name === name);
    if (selected) {
      this.processForm.get('philhealth')?.setValue(selected.value);
    }
  }

  onPagIbigSelected(name: string) {
    const selected = this.pagibig.find(e => e.name === name);
    if (selected) {
      this.processForm.get('pagibig')?.setValue(selected.value);
    }
  }

  onScheduleSelected(name: string) {
    const selected = this.schedules.find(c => c.name === name);
    if (selected) {
      this.processForm.get('schedule')?.setValue(selected.id);
    }
  }

  onSubmit(): void {
    this.loading = true;
    if (this.processForm.valid) {
      const formData = this.processForm.value;
      this.processSchedulerService.insert_payroll_invoice(formData).subscribe((res) => {
        this.loading = false;
        this.dialogRef.close();
        window.location.reload();
      })
    } else {
      this.loading = false;
      console.log('Form is invalid');
    }
  }
}
